<template>
  <div class="report-status" :class="{ 'report-status--warning': delayed }" role="status">
    <strong>{{ loading ? 'Loading report…' : delayed ? 'Collection needs attention' : 'Playback reporting' }}</strong>
    <p v-if="!loading">{{ delayed ? 'The collection job has not reported recently. Recent activity may be delayed; zero does not necessarily mean no viewers.' : 'New playback activity is collected in batches, normally visible within two minutes.' }}</p>
    <p>Historical reports are preserved. The former collector stopped supplying data in October 2023; missing activity before collection was restored in September 2026 cannot be reconstructed.</p>
  </div>
</template>
<script>
export default {
  props: { report: { type: Object, default: () => ({}) }, loading: Boolean },
  computed: {
    delayed() {
      const time = Date.parse(this.report.collection && this.report.collection.last_flush);
      return !Number.isFinite(time) || Date.now() - time > 10 * 60 * 1000;
    },
  },
};
</script>
<style scoped>
.report-status { padding: 16px 20px; border: 1px solid var(--gs-border); border-radius: 12px; background: #f3f8ff; color: #334155; margin: 16px 0; font-size: 13px; line-height: 1.6; }
.report-status p { margin: 4px 0 0; }
.report-status--warning { background: #fff8eb; border-color: #e8c98a; color: #744b14; }
</style>
